// Components==============
import React, { createContext } from 'react';
// =========================

type FormContextTypes = {
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  errors: any;
  formValues: any;
  setFormValues?: React.Dispatch<any>;
};

export const FormContext = createContext({} as FormContextTypes);

export default function FormContextWrapper({
  onChange,
  errors,
  formValues,
  setFormValues,
  children,
}: FormContextTypes & { children: React.ReactNode }) {
  return (
    <FormContext.Provider
      value={{ onChange, errors, formValues, setFormValues }}
    >
      {children}
    </FormContext.Provider>
  );
}
